import { site } from "@/config/site";

export function canonical(path: string): string {
  const normalized = path.startsWith("/") ? path : `/${path}`;
  return `${site.origin}${normalized === "/" ? "/" : normalized.replace(/\/$/, "")}`;
}

export function personJsonLd() {
  return {
    "@context": "https://schema.org",
    "@type": "Person",
    name: site.name,
    jobTitle: site.jobTitle,
    worksFor: {
      "@type": "Organization",
      name: site.worksFor,
      url: site.profiles.ecosystem,
    },
    url: site.origin,
    image: `${site.origin}${site.portraits.primary.src}`,
    alumniOf: site.alumniOf,
    knowsAbout: [...site.knowsAbout],
    sameAs: [
      site.profiles.linkedin,
      site.profiles.github,
      site.profiles.githubOrg,
      site.profiles.ecosystem,
      site.profiles.ecosystemCode,
      site.profiles.academia,
      site.profiles.researchgate,
    ],
  };
}

export function bookJsonLd(title: string, url: string, datePublished?: string) {
  return {
    "@context": "https://schema.org",
    "@type": "Book",
    name: title,
    author: { "@type": "Person", name: site.name },
    url,
    datePublished,
  };
}
